const CLOUD_METAL_TYPES: readonly string[] = [
	'Cloud.Metal',
	'Cloud.Metal.WIN',
	'Cloud.Metal.CCC',
	'Cloud.Metal.WIN.CCC',
];

/**
 * Whether the asset is a Cloud Metal server, going by its product code (the
 * asset's `type`). Matching is case-sensitive.
 *
 * Mirrors the `Cloud.Metal*` codes in banana-stand's `getIsCloudDedicated`
 * (`@liquidweb-dev/banana-stand/parsers`). That helper also matches the legacy
 * `SS.VM*` codes, which are deliberately left out: Cloud Metal here means the
 * `Cloud.Metal*` codes only.
 *
 * Both the servers list menu item and the detail page's primary button read
 * this, so Cloud Metal is handled the same way on both surfaces.
 */
const isCloudMetal = (type?: string | null) =>
	CLOUD_METAL_TYPES.includes(type ?? '');

export default isCloudMetal;
